const getYahooTime = (numberOfMinutes) => {
    const hours = Math.floor(numberOfMinutes / 60);
    const minutes = numberOfMinutes % 60;
    return `${String(hours).padStart(2, "0")}${String(minutes).padStart(2, "0")}`;
};
export const createYahooDuration = (e) => {
    const minutes = Math.floor((new Date(e.endTime) - new Date(e.startTime)) / 60 / 1000);
    return getYahooTime(minutes);
};
export const createTime = (t) => {
    return new Date(t).toISOString();
};
export const createTimeSanitized = (t) => new Date(t).toISOString().replace(/[-:]|\.\d{3}/g, "");
export const createUrl = (base, query) => Object.keys(query).reduce((accum, key, index) => {
    const value = query[key];
    if (value !== null) {
        return `${accum}${index === 0 ? "?" : "&"}${key}=${encodeURIComponent(value)}`;
    }
    return accum;
}, base);
export const createICSCalendarUrl = (e) => {
    const icsInfos = [
        "BEGIN:VCALENDAR",
        "VERSION:2.0",
        "BEGIN:VEVENT",
        `URL:${document.URL}`,
        `DTSTART:${createTimeSanitized(e.startTime)}`,
        `DTEND:${createTimeSanitized(e.endTime)}`,
        `SUMMARY:${e.title}`,
        `DESCRIPTION:${e.description}`,
        `LOCATION:${e.location}`,
        "END:VEVENT",
        "END:VCALENDAR",
    ];
    return encodeURI(`data:text/calendar;charset=utf8,${icsInfos.join("\n")}`);
};
/**
 * @param {e} e incoming event
 * @description see this for documentation: https://www.labnol.org/apps/calendar.html, https://github.com/InteractionDesignFoundation/add-event-to-calendar-docs/blob/master/services/yahoo.md
 * @returns {string} an encoded url to add event to yahoo calendar
 */
export const createYahooCalendarUrl = (e) => createUrl("https://calendar.yahoo.com", {
    v: 60,
    view: "d",
    type: 20,
    title: e.title,
    st: createTimeSanitized(e.startTime),
    dur: createYahooDuration(e),
    desc: e.description,
    in_loc: e.location,
});
/**
 * @param {e} e incoming event
 * @description see this for documentation: https://www.labnol.org/apps/calendar.html
 * @returns {string} an encoded url to add event to outlook live calendar
 */
export const createOutlookLiveCalendarUrl = (e) => createUrl("https://outlook.live.com/owa", {
    rru: "addevent",
    startdt: createTime(e.startTime),
    enddt: createTime(e.endTime),
    subject: e.title,
    location: e.location,
    body: e.description,
    allday: false,
    uid: new Date(e.startTime).getTime().toString(),
    path: "/calendar/view/Month",
});
/**
 * @param {e} e incoming event
 * @description see this for documentation: https://www.labnol.org/apps/calendar.html
 * @returns {string} an encoded url to add event to outlook live calendar
 */
export const createOutlookOfficeCalendarUrl = (e) => createUrl("https://outlook.office.com/owa", {
    rru: "addevent",
    startdt: createTime(e.startTime),
    enddt: createTime(e.endTime),
    subject: e.title,
    location: e.location,
    body: e.description,
    allday: false,
    uid: new Date(e.startTime).getTime().toString(),
    path: "/calendar/view/Month",
});
/**
 * @param {e} e incoming event
 * @description see this for documentation: https://www.labnol.org/apps/calendar.html
 * @returns {string} an encoded url to add event to google calendar
 */
export const createGoogleCalendarUrl = (e) => createUrl("https://calendar.google.com/calendar/render", {
    action: "TEMPLATE",
    dates: `${createTimeSanitized(e.startTime)}/${createTimeSanitized(e.endTime)}`,
    location: e.location,
    text: e.title,
    details: e.description,
});
//# sourceMappingURL=helpers.js.map